<template>
  <div>
    <Table
      :no-data-text="$t('common.noData')"
      :columns="columns"
      :data="tableData"
      style="width: 100.1%"
    ></Table>
    <!-- :page-size-opts="[2,4,6,8]" -->
    <Page
      :current="current"
      :total="dataTotal"
      show-sizer
      :page-size="pageSize"
      @on-change="changePage"
      @on-page-size-change="changeSize"
      :transfer="true"
    ></Page>
  </div>
</template>
<script>
var tableDataVue = {};
export default {
  name: "TableReservedInstances",
  data() {
    return {
      current: 1,
      dataTotal: 0,
      pageSize: 10,
      accountIds: [],
      columns: [
        {
          title: this.$t("RAM.AWS.computeInstance.accountName"),
          key: "accountName",
        },
        {
          title: this.$t("RAM.AWS.computeInstance.accountID"),
          key: "accountIdString",
        },
        {
          title: this.$t("RAM.AWS.computeInstance.region"),
          key: "region",
        },
        {
          title: this.$t("RAM.ALI.ReservedInstances.name"),
          key: "reservedInstanceName",
        },
        {
          title: this.$t("RAM.ALI.ReservedInstances.reservedInstanceId"),
          key: "reservedInstanceId",
        },
        {
          title: this.$t("RAM.ALI.ReservedInstances.platform"),
          key: "platform",
        },
        {
          title: this.$t("RAM.ALI.ReservedInstances.instanceType"),
          key: "instanceType",
        },
        {
          title: this.$t("RAM.ALI.ReservedInstances.status"),
          key: "status",
        },
        {
          title: this.$t("RAM.ALI.ReservedInstances.creationTime"),
          key: "creationTime",
        },
        {
          title: this.$t("RAM.ALI.ReservedInstances.expiredTime"),
          key: "expiredTime",
        },
        {
          title: this.$t("RAM.ALI.ReservedInstances.instanceAmount"),
          key: "instanceAmount",
        }
      ],
      tableData: [],
    };
  },
  beforeCreate: function () {
    tableDataVue = this;
  },
  created() {
    // 获取搜索内容
    eventBus.$on("companyId", function (val) {
      tableDataVue.companyId = val;
    });
    eventBus.$on("accountName", function (val) {
      tableDataVue.accountName = val;
    });
    eventBus.$on("reservedInstanceId", function (val) {
      tableDataVue.reservedInstanceId = val;
    });
  },
  mounted: function () {
    // tableDataVue.getData();
  },
  methods: {
    showAll: function () {
      tableDataVue.getData();
    },
    // 分页显示数据
    /****************************************************/
    getData: function () {
      // 获取搜索内容
      eventBus.$on("companyId", function (val) {
        tableDataVue.companyId = val;
      });
      eventBus.$on("accountName", function (val) {
        tableDataVue.accountName = val;
      });
      eventBus.$on("reservedInstanceId", function (val) {
        tableDataVue.reservedInstanceId = val;
      });
      this.$api.resourceManagement
        .pagingQueryAliEcsReservedInstance({
          accountName: tableDataVue.accountName,
          companyId: tableDataVue.companyId,
          pageNum: this.current,
          pageSize: this.pageSize,
          reservedInstanceId: this.reservedInstanceId
        })
        .then((res) => {
          this.tableData = res.data.records;
          // 当前页
          this.current = res.data.current;
          // 总条数
          this.dataTotal = res.data.total;
        });
    },
    changePage: function (current) {
      this.current = current;
      tableDataVue.getData();
    },
    changeSize: function (pageSize) {
      this.pageSize = pageSize;
      tableDataVue.getData();
    },
  },
};
</script>
<style scoped>
.ivu-page {
  margin-top: 10px !important;
  margin-bottom: 30px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/configuration/resource_configuration_management/ali/reservedInstances/TableReservedInstances.vue